import StorageServiceClient from './StorageServiceClient';
var mathStorageService = new StorageServiceClient('math-storage');
export default mathStorageService;